export default "__VITE_ASSET__56460c31__"